const orderItemTypes = {
  new: "new",
  view: "view",
  edit: "edit",
};

export default orderItemTypes;
